import React from 'react';
import Button from '../../components/Form/Button';
import Input from '../../components/Form/Input';
import Select from '../../components/Form/Select';

interface ReportGenerationFormProps {
  reportType: string;
  onReportTypeChange: (value: string) => void;
  selectedModule: string;
  onModuleChange: (value: string) => void;
  exchangeRate: number;
  onExchangeRateChange: (value: number) => void;
  dateFrom: string;
  onDateFromChange: (value: string) => void;
  dateTo: string;
  onDateToChange: (value: string) => void;
  onGenerate: () => void;
  isGenerating: boolean;
  isLoading: boolean;
  reportTypeOptions: { value: string; label: string }[];
  moduleOptions: { value: string; label: string }[];
}

const ReportGenerationForm: React.FC<ReportGenerationFormProps> = ({
  reportType, onReportTypeChange, selectedModule, onModuleChange,
  exchangeRate, onExchangeRateChange, dateFrom, onDateFromChange,
  dateTo, onDateToChange, onGenerate, isGenerating, isLoading,
  reportTypeOptions, moduleOptions,
}) => (
  <div className="bg-white shadow rounded-lg">
    <div className="px-4 py-5 sm:p-6">
      <h3 className="text-lg leading-6 font-medium text-gray-900 mb-4">Generate Report</h3>
      
      <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-4">
        <div>
          <Select
            label="Report Type"
            value={reportType}
            onChange={(e) => onReportTypeChange(e.target.value)}
            options={reportTypeOptions}
          />
        </div>
        
        <div>
          <Select
            label="Module"
            value={selectedModule}
            onChange={(e) => onModuleChange(e.target.value)}
            options={moduleOptions}
          />
        </div>
        
        <div>
          <Input
            label="Exchange Rate (USD to EGP)"
            type="number"
            step="0.01"
            value={exchangeRate}
            onChange={(e) => onExchangeRateChange(parseFloat(e.target.value) || 50.0)}
            placeholder="50.00"
          />
        </div>

        <div>
          <Input
            label="From Date"
            type="date"
            value={dateFrom}
            onChange={(e) => onDateFromChange(e.target.value)}
          />
        </div>

        <div>
          <Input
            label="To Date"
            type="date"
            value={dateTo}
            onChange={(e) => onDateToChange(e.target.value)}
          />
        </div>

        <div className="flex items-end">
          <Button 
            onClick={onGenerate}
            disabled={isGenerating || isLoading}
            className="w-full"
          >
            {isGenerating ? 'Generating...' : 'Update Report'}
          </Button>
        </div>
      </div>
    </div>
  </div>
);

export default ReportGenerationForm;
